import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { ToastService } from 'src/app/services/general/toast.service';

export enum ToastType {
  basic,
  success,
  alert,
  warn,
  info
}

@Component({
    selector: 'toast-notification',
    templateUrl: './toast-notification.component.html',
    styleUrls: ['./toast-notification.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatIcon]
})
export class ToastNotificationComponent implements OnInit, OnDestroy {

  @ViewChild('notification') notificationHtml: TemplateRef<any>;

  //  icone e classi per le notifiche
  notificationIcons = {
    success: {
      icon: 'check_circle_outline'
    },
    error: {
      icon: 'error_outline'
    },
    alert: {
      icon: 'warning_amber'
    },
    warn: {
      icon: 'warning_amber'
    },
    info: {
      icon: 'info'
    },
  }

  subscription: Subscription;

  constructor(private snackBar: MatSnackBar, private toast: ToastService) {
  }

  ngOnInit(): void {
    this.subscription = this.toast.onMessage().subscribe(context => {
      if (this.notificationHtml) {
        this.snackBar.openFromTemplate(this.notificationHtml, {
          data: context,
          duration: 4000,
          horizontalPosition: 'end',
          verticalPosition: 'top',
          panelClass: 'toast-snackbar',
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
